import { useEffect } from 'react';
import { BlockList } from '../blocks/block-list';
import { FlowCanvas } from '../canvas/flow-canvas';
import { DraftTestPanel } from '../test/draft-test-panel';
import { BuildToolbar } from './build-toolbar';
import { useCustomToolBuilder } from './builder-context';

/** Typing keeps the field's own undo, and a dialog (such as a write confirmation) must not change the draft behind it. */
const keepsUndo = (target: EventTarget | null): boolean =>
	target instanceof HTMLElement &&
	(target.isContentEditable || ['INPUT', 'TEXTAREA'].includes(target.tagName) || !!target.closest('[role="dialog"], [role="alertdialog"]'));

/**
 * The steps fill the stage, as a canvas or as blocks; the test run slides over its right side. ⌘Z or Ctrl+Z
 * undoes an edit, except while typing or in a dialog.
 */
export const BuildStage = () => {
	const { testing, undo, view } = useCustomToolBuilder();
	const { run } = undo;
	useEffect(() => {
		const onKeyDown = (event: KeyboardEvent) => {
			if (!(event.metaKey || event.ctrlKey) || event.shiftKey || event.key.toLowerCase() !== 'z' || keepsUndo(event.target)) return;
			event.preventDefault();
			run();
		};
		window.addEventListener('keydown', onKeyDown);
		return () => window.removeEventListener('keydown', onKeyDown);
	}, [run]);

	return (
		<div className='flex min-h-0 flex-1 flex-col'>
			<BuildToolbar />
			<div className='relative flex min-h-0 flex-1 flex-col'>
				{view === 'canvas' ? <FlowCanvas /> : <BlockList />}
				{testing.open && <DraftTestPanel />}
			</div>
		</div>
	);
};
